<template>
  <div style="border: 1px solid black;">
    Hello timeslot calendar!
    <div style="border: 1px solid black;">
      <b-button @click="changeSelPeriod(-12)">
        &lt;&lt;
      </b-button>
      <b-button @click="changeSelPeriod(-1)">
        &lt;
      </b-button>
      <b-button @click="changeSelPeriod(0)">
        {{ selYear }} -- {{ selMonth+1 }}
      </b-button>
      <b-button @click="changeSelPeriod(1)">
        &gt;
      </b-button>
      <b-button @click="changeSelPeriod(12)">
        &gt;&gt;
      </b-button>
    </div>
    <b-container fluid>
      <b-row style="border: 1px solid red;">
        <b-col v-for="wd in weekDays" :key="wd" style="border: 1px solid blue;">{{ wd }}</b-col>
      </b-row>
      <b-row v-for="(mw, mwndx) in monthWeeks" :key="mwndx" style="border: 1px solid red;">
        <b-col v-for="(mwd, mwdndx) in mw" :key="mwdndx" style="border: 1px solid blue; padding: 5px;">
          <div>
            <i class="mdi mdi-checkbox-blank" :style="{ color: getSpan1Color(mwd) }"></i>
            <i class="mdi mdi-checkbox-blank" :style="{ color: getSpan2Color(mwd) }"></i>
          </div>
          <b-button size="sm" variant="outline-primary" @click="changeSelDay(mwd)">
            {{ mwd.calDay }}
          </b-button>
        </b-col>
      </b-row>
    </b-container>
    <div v-if="selDay">
      <b-container>
        <div>
        the slots for {{ selDay.calDay }} / {{ selMonth }} / {{ selYear }}
        </div>
        <b-row>
          <b-col v-for="(sl,slndx) in timeSlotsType" :key="slndx">
            <b-button
              :style="{ 'background-color': getSlotBtnColor(sl), width: '100%' }"
              @click="changeSelSlot(sl)">
              {{ sl }}
            </b-button>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <div v-if="selSlot">
      <div>
        <b-container>
          Enter an appointment for the timeslot: {{ selSlot }}
          <b-row cols="1" cols-sm="3" cols-md="12">
            <b-col>
              <input
                v-if="!hasOccasionsList() || (isAdmin() && isSelSlotOccupied())"
                id="title"
                class="form-control"
                v-model="formData.appt.title"
                placeholder="Occasion"
                :disabled="isAdmin() && isSelSlotOccupied()" />
              <select
                v-else
                class="custom-select"
                v-model="formData.occasionSelected">
                <option disabled value="null">Please select one</option>
                <option
                  v-for="(opt, ndx) in formData.occasionsList"
                  :key="ndx"
                  :value="ndx">{{ opt }}</option>
              </select>
                <textarea
                  id="textarea"
                  class="form-control"
                  v-model="formData.appt.descr"
                  placeholder="Enter description ..."
                  rows="3"
                  max-rows="6" />
            </b-col>
            <b-col>
              <input
                id="name"
                class="form-control"
                v-model="formData.appt.name"
                placeholder="Name"
                :disabled="isAdmin() && isSelSlotOccupied()" />
            </b-col>
            <b-col>
              <input
                id="email"
                class="form-control"
                v-model="formData.appt.email"
                placeholder="eMail"
                :disabled="isAdmin() && isSelSlotOccupied()" />
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-button @click="handleOccpySelSlot()">Occupy</b-button>
            </b-col>
            <b-col>
              <b-button v-if="isAdmin()" @click="handleDelSelSlot()">Delete</b-button>
            </b-col>
            <b-col>
              <b-button @click="handleCancelSelSlot()">Cancel</b-button>
            </b-col>
          </b-row>
        </b-container>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import config from '@/config'

const timeSlotValueType = {
	locked: 'lck', // locked - no event can be added
	unlocked: 'ulck', // unlocked - event can be added
	editLocked: 'elck', // editLocked - locked for editing (new, edit, delete)
	occupied: 'occp' // occupied - already occupied
}

const calMonthType = {
	prev: 'prev', // previous month
	curr: 'curr', // current month
	next: 'next' // next month
}

const modeType = {
  customer: 'customer',
  admin: 'admin'
}

const DEFAULT_APPT = { title: '', descr: '', name: '', email: '' }

export default {
  name: 'timeslot-calendar',
  version: '0.0.1',
  props: {
    mode: { // customer / admin
      type: String,
      default: modeType.customer,
      validator: function (v) {
        return [modeType.customer, modeType.admin].indexOf(v) !== -1
      }
    },
    instKey: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      timeSlotsType: ['8:00', '9:00', '10:00', '11:00', '12:00', '13:00',
        '14:00', '15:00', '16:00', '17:00', '18:00'],
      weekDays: ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa', 'So'],
      monthWeeks: [],
      monthSlots: {},
      selSlot: null,
      // selSlotOrigStatus: null,
      selDay: null,
      selYear: (new Date()).getFullYear(), // selected year in the calendar header
      selMonth: (new Date()).getMonth(), // selected month (0 - 11)
      formData: {
        occasionSelected: null,
        occasionsList: [],
        appt: Object.assign({}, DEFAULT_APPT)
      }
    }
  }, // data
  async mounted() {
    // TODO: check if necessary
    this.refreshData()
  }, // mounted
  methods: {
    async refreshData () {
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/schedule/' + this.instKey +
          '/timeslotCaldr/' + this.selYear + '/' + this.selMonth)
        // this.content = resp.data
        this.monthSlots = _resp.data.payload.timeslotCaldr
        console.log('TRACE-REMOVE: TimeslotCalendar: resp is: ', _resp)
      } catch (e) {
        this.content = 'Error loading the content!'
        console.error('ERROR: Exception is: ', e)
      }
      this.monthWeeks = this.getMonthWeeks(this.selYear, this.selMonth)
      try {
        const _resp = await axios.get(config.glapiBaseUri + '/schedule/' + this.instKey +
          '/occasionsList')
        // this.formData.occasionsList = _resp.data.payload.occasionsList.map((e, i) => { return {value: i, text: e} })
        this.formData.occasionsList = _resp.data.payload.occasionsList
      } catch (e) {
        console.error('ERROR: Exception getting the occasionsList is: ', e)
      }
      // this.formData.occasionsList.unshift({ value: null, text: 'Please selecr value' })
    }, // refreshData
    hasOccasionsList () {
      return this.formData.occasionsList.length > 0
    }, // hasOccasionsList
    changeSelPeriod(months) {
      const newDate = new Date(this.selYear, this.selMonth + months, 1)
      this.selYear = newDate.getFullYear()
      this.selMonth = newDate.getMonth()
    }, // changeSelPeriod
    changeSelDay (selDay) {
      this.selSlot = null
      this.selDay = null
      if (this.isCurrMonth(selDay)) {
        this.selDay = selDay
      }
    }, // changeSelDay
    async changeSelSlot(sl) {
      this.selSlot = null
      if (this.mode === modeType.admin) {
        if (!this.monthSlots[this.selDay.calDay] ||
          !this.monthSlots[this.selDay.calDay].slots[sl] ||
          this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.locked) {
          await axios.post(config.glapiBaseUri + '/schedule/' + this.instKey +
            '/timeslotCaldr/' + this.selYear + '/' + this.selMonth + '/' +
            this.selDay.calDay + '/' + sl)
          this.refreshData()
        } else if (this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.unlocked ||
          this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.occupied) {
          this.selSlot = sl
          if (this.monthSlots[this.selDay.calDay].appts &&
            this.monthSlots[this.selDay.calDay].appts[sl]) {
            this.formData.appt = this.monthSlots[this.selDay.calDay].appts[sl]
          } else {
            this.formData.occasionSelected = null
            this.formData.appt = Object.assign({}, DEFAULT_APPT)
          }
        }
      } else if (this.mode === modeType.customer) {
        if (this.monthSlots[this.selDay.calDay] &&
          this.monthSlots[this.selDay.calDay].slots[sl] &&
          this.monthSlots[this.selDay.calDay].slots[sl] === timeSlotValueType.unlocked) {
          this.selSlot = sl
          this.formData.occasionSelected = null
          this.formData.appt = Object.assign({}, DEFAULT_APPT)
        }
      }
    }, // changeSelSlot
    async handleDelSelSlot () {
      // TODO: check if this restriction makes sence?
      if (this.monthSlots[this.selDay.calDay] &&
        this.monthSlots[this.selDay.calDay].slots[this.selSlot] !== timeSlotValueType.locked) {
        await axios.delete(config.glapiBaseUri + '/schedule/' + this.instKey +
          '/timeslotCaldr/' + this.selYear + '/' + this.selMonth + '/' +
          this.selDay.calDay + '/' + this.selSlot)
        this.refreshData()
        this.selSlot = null
      }
    }, // handleDelSelSlot
    async handleOccpySelSlot () {
      console.log('TRACE-REMOVE: TimeslotCalendar.handleOccpySelSlot: this.formData.appt is: ', this.formData.appt)
      console.log('TRACE-REMOVE: TimeslotCalendar.handleOccpySelSlot: this.formData.occasionSelected is: ', this.formData.occasionSelected)
      console.log('TRACE-REMOVE: TimeslotCalendar.handleOccpySelSlot: this.formData.occasionSelected is: ', this.formData.occasionSelected)
      if (this.hasOccasionsList) {
        this.formData.appt.title = this.formData.occasionsList[this.formData.occasionSelected]
      }
      await axios.put(config.glapiBaseUri + '/schedule/' + this.instKey +
        '/timeslotCaldr/' + this.selYear + '/' + this.selMonth + '/' +
        this.selDay.calDay + '/' + this.selSlot,
        {
          status: timeSlotValueType.occupied,
          appt: this.formData.appt
        })
      this.refreshData()
      this.selSlot = null
    }, // handleOccpySelSlot
    handleCancelSelSlot () {
      this.selSlot = null
    }, // handleCancelSelSlot
    getSlotBtnColor (sl) {
      let _color = 'gray'
      let _slotValue
      if (this.monthSlots[this.selDay.calDay]) {
        _slotValue = this.monthSlots[this.selDay.calDay].slots[sl]
      }
      if (_slotValue == timeSlotValueType.unlocked) {
        _color = 'green'
      } else if (_slotValue == timeSlotValueType.occupied) {
        _color = 'red'
      } else if (_slotValue == timeSlotValueType.editLocked) {
        _color = 'blue'
      }
      return _color
    }, // getSlotBtnColor
    getSpan1Color (wd) {
      var _color = 'gray'
      if (this.isCurrMonth(wd)){
        if (this.hasSlotsOfType(wd.calDay, timeSlotValueType.unlocked)) {
          _color = 'green'
        } else if (this.hasAllSlotsOfType(wd.calDay, timeSlotValueType.occupied)) {
          _color = 'red'
        }
      }
      return _color
    }, // getSpan1Color
    getSpan2Color (wd) {
      var _color = 'gray'
      if (this.isCurrMonth(wd)){
        if (this.hasAllSlotsOfType(wd.calDay, timeSlotValueType.unlocked)) {
          _color = 'green'
        } else if (this.hasSlotsOfType(wd.calDay, timeSlotValueType.occupied)) {
          _color = 'red'
        }
      }
      return _color
    }, // getSpan2Color
    hasSlotsOfType (day, slType) {
      var _ret = false
      if (this.monthSlots[day] && this.monthSlots[day].slots) {
        if (Object.values(this.monthSlots[day].slots).some(e => e === slType)) {
          _ret = true
        }
      }
      return _ret
    }, // hasSlotsOfType
    hasAllSlotsOfType (day, slType) {
      var _ret = true
      if ((!this.monthSlots[day] || !this.monthSlots[day].slots)) {
        _ret = false
      } else if (this.monthSlots[day] && this.monthSlots[day].slots) {
        const _slotsValues = Object.values(this.monthSlots[day].slots)
        if (this.timeSlotsType.length !== _slotsValues.length ||
          _slotsValues.some(e => e !== slType)) {
          _ret = false
        }
      }
      return _ret
    }, // isAllEventSlotsOfEvType
    isAdmin () {
      return this.mode === modeType.admin
    }, // isAdmin
    isSelSlotOccupied () {
      let ret = false
      if (this.selSlot && this.monthSlots[this.selDay.calDay] &&
        this.monthSlots[this.selDay.calDay].slots[this.selSlot] &&
        this.monthSlots[this.selDay.calDay].slots[this.selSlot] === timeSlotValueType.occupied) {
        ret = true
      }
      return ret
    }, // isSelSlotOccupied
    // TODO: externalize it!
    isCurrMonth (month) {
      var currMonth = false
      if (month.calMonth === calMonthType.curr) {
        currMonth = true
      }
      return currMonth
    }, // isCurrMonth
    getMonthWeeks (year, month011) {
      let weeksDays = [],
        weekDays = [],
        numDaysMonth = (new Date(year, month011+1, 0)).getDate(),
        currentDOM = 1,
        startDOWMoSu17 = (new Date(year, month011, 1)).getDay() !== 0 ?
          (new Date(year, month011, 1)).getDay() : 7

      var i
      // calculate first week last/prev month days
      for (i = (-1*startDOWMoSu17 + 2); i < currentDOM; i++) {
        weekDays.push({ calDay: (new Date(year, month011, i)).getDate(),
          calMonth: calMonthType.prev })
      }
      // first week this/current month days
      for (i = startDOWMoSu17; i <= 7; i++) {
        weekDays.push({ calDay: currentDOM++, calMonth: calMonthType.curr })
      }
      weeksDays.push(weekDays)
      weekDays = []

      // this/current month full weeks
      do {
        for (i = 1; i <= 7; i++) {
          weekDays.push({ calDay: currentDOM++, calMonth: calMonthType.curr })
        }
        weeksDays.push(weekDays)
        weekDays = []
      } while ((currentDOM+6) <= numDaysMonth)

      // last week this/current month
      if (currentDOM <= numDaysMonth) {
        var daysRemaining = 7
        while (currentDOM <= numDaysMonth) {
          weekDays.push({ calDay: currentDOM++, calMonth: calMonthType.curr })
          daysRemaining--
        }
        // last week days next month
        for (i = 1; i <= daysRemaining; i++) {
          weekDays.push({ calDay: (new Date(year, month011+1, i)).getDate(),
            calMonth: calMonthType.next })
        }
        weeksDays.push(weekDays)
      }
      return weeksDays
    } // getMonthWeeks
  } // methods
}
</script>

<style scoped>
@import '~@mdi/font/css/materialdesignicons.min.css';
@import '~bootstrap/dist/css/bootstrap.css';
</style>
